export default "__VITE_ASSET__Dao7ldHK__"